import styled from 'styled-components';
import { background, border, color, compose, flexbox, grid, layout, position, shadow, space, system, typography, } from 'styled-system';
const boxSizing = system({
    boxSizing: {
        property: 'boxSizing',
    },
});
const cursor = system({
    cursor: {
        property: 'cursor',
    },
});
const outline = system({
    outline: {
        property: 'outline',
    },
});
const textDecoration = system({
    textDecoration: {
        property: 'textDecoration',
    },
});
const transition = system({
    transition: {
        property: 'transition',
    },
});
const aspectRatio = system({
    aspectRatio: {
        property: 'aspectRatio',
    }
});
const objectFit = system({
    objectFit: {
        property: 'objectFit',
    },
});
const styleProps = compose(background, border, boxSizing, color, cursor, flexbox, grid, layout, outline, position, shadow, space, textDecoration, transition, aspectRatio, objectFit, typography);
export const Box = styled.div.attrs(({ boxSizing = 'border-box', }) => ({
    boxSizing,
}))(styleProps);
